import React from "react";

const CareerIntro = ({ scrollToApplyForm }) => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-[#f0f7f3] to-white 
    py-16 md:py-14 lg:py-20 px-4 sm:px-6 lg:px-8">
      {/* Background decorative elements */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 transform">
        <div className="w-64 h-64 rounded-full bg-[#0e4322]/10 blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center">
          {/* Heading with improved gradient */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#0F172A] font-amiriQuran leading-tight">
            Join Our Team And Shape The{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0e4322] to-[#3a5630]">
              Future Together
            </span>
          </h1>

          {/* Subheading with NextEra Research highlight */}
          <div className="mt-6 inline-flex items-center bg-[#def3d4] rounded-full px-4 py-2">
            <span className="text-lg font-medium text-[#0e4322]">
              At <span className="font-bold">NextEra Research</span>
            </span>
          </div>

          {/* Description text */}
          <p className="mt-8 text-xl md:text-2xl text-[#1F2937] leading-relaxed max-w-4xl mx-auto">
            We embrace the philosophy of{' '}
            <span className="font-bold text-[#0e4322]">"EMPLOYEE FIRST"</span> by empowering
            our team with the right knowledge, skills, and recognition—fostering
            growth, support, and mutual success.
          </p>

          {/* CTA Button with hover animation */}
          <div className="mt-12">
            <button
              onClick={scrollToApplyForm}
              className="relative inline-flex items-center justify-center px-10 py-4 md:px-12 md:py-3 overflow-hidden text-xl font-bold rounded-full group bg-gradient-to-r from-[#0e4322] to-[#3a5630] text-white hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              <span className="relative z-10">Join Our Team</span>
              <span className="absolute inset-0 bg-gradient-to-r from-[#3a5630] to-[#0e4322] opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full"></span>
              <svg className="w-5 h-5 ml-3 relative z-10 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </button>
          </div>

          {/* Stats grid - optional addition */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-3 gap-6 max-w-4xl mx-auto items-center">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="text-3xl font-bold text-[#0e4322]">50+</div>
              <div className="text-gray-600 mt-2">Team Members</div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="text-3xl font-bold text-[#0e4322]">100%</div>
              <div className="text-gray-600 mt-2">Employee Focus</div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <div className="text-3xl font-bold text-[#0e4322]">24/7</div>
              <div className="text-gray-600 mt-2">Support</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerIntro;
